import { render, staticRenderFns } from "./NewsIndustryBar.vue?vue&type=template&id=4ff5ffe2"
import script from "./NewsIndustryBar.vue?vue&type=script&lang=js"
export * from "./NewsIndustryBar.vue?vue&type=script&lang=js"
import style0 from "./NewsIndustryBar.vue?vue&type=style&index=0&id=4ff5ffe2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports